"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refPropType = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
// This must be a function so that a new PropType object is created each time,
// otherwise all props using this type will copy the same description
const refPropType = () => _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.func, _stencilReactDesc.PropTypes.shape({
  current: _stencilReactDesc.PropTypes.any
})]);
exports.refPropType = refPropType;